import { render, staticRenderFns } from "./SharingInput.vue?vue&type=template&id=65987c6a"
import script from "./SharingInput.vue?vue&type=script&lang=js"
export * from "./SharingInput.vue?vue&type=script&lang=js"
import style0 from "./SharingInput.vue?vue&type=style&index=0&id=65987c6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports